import React, { Component, Fragment } from 'react';

import * as Func from '../../../../../../helpers/functions';
import { DATE_TIME_FORMAT, ORDER } from '../../../../../../constants/Define';
import i18n from '../../../../../../constants/initLng';
import { getMomentDate } from '../../../../../../utils/commonUtils';
import {
    FormWrapperItem, ListComponent, StatusComponent,
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import Span from "../../../../common/component/Span";
import { Skeleton } from 'antd';
import Order, { OrderVinWonderBookingItems, OrderVinWonderBookingCustomer } from '../../../../../../models/Order';
import EllipsisText from '../../../../common/component/EllipsisText';
import { Tooltip, Icon } from 'antd';
import SurchargeInfo from '../SurchargeInfo/SurchargeInfo';
import moment from 'moment';

import './VinWonderInfo.less';
import DetailStatusItem from '../DetailStatusItem';
const removedColumns = [
    'orderId', 'productVariantId', 'siteCode',
    'originalPrice', 'quantity',
    'childOriginalPrice', 'childSalePrice', 'childQuantity',
    'seniorOriginalPrice', 'seniorSalePrice', 'seniorQuantity',
    'itemVariantId', 'detail', 'statusText',
    'nationalityID', 'zonePickupId', 'zoneReleaseId', 'identityType', 'sessionInfo',
];
const OrderVinWonderItemKeys = Object.getOwnPropertyNames(new OrderVinWonderBookingItems());
const OrderVinWonderCustomerKeys = Object.getOwnPropertyNames(new OrderVinWonderBookingCustomer());
const statusDisabledChange = [3, 4, 5, 13]
export default class VinWonderInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleOrderItemTable: Func.getTitleTable(['action', ...OrderVinWonderItemKeys], [], removedColumns),
            titleOrderCustomerTable: Func.getTitleTable([...OrderVinWonderCustomerKeys], [], removedColumns),
            modelOrderItem: OrderVinWonderItemKeys,
            modelOrderCustomer: OrderVinWonderCustomerKeys,
            componentTable: {
                vinWonderName: {
                    width: 300,
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                vinWonderTicketName: {
                    width: 250
                },
                usingDate: {
                    render: (date, record) => {
                    return date && <div>
                        {getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE)}&nbsp;{record.sessionInfo && <span>{record.sessionInfo?.startHour}:{record.sessionInfo?.startMinute}</span>}
                    </div>
                    }
                },
                ticketType: {
                    render: (text, record) => text && this.props.t(`item.vinWonder.${text}`)
                },
                salePrice: {
                    render: (text, record) => Func.formatMoney(record.salePrice || '') + this.props.t('currencySymbol')
                },
                status: {
                    key: 'status',
                    render: (value, record) => {
                        return value && <Fragment>
                            <StatusComponent color={this.props.t(`item.order.orderItemStatusColor.${value}`)}
                                label={this.props.t(`item.order.orderItemStatus.${value}`)} />
                            {record.isLocked && <Icon type="lock" style={{ color: 'red' }} />}
                        </Fragment>
                    },
                },
                action: {
                    width: 100,
                    align: 'center',
                    render: (text, record) => <Fragment>
                        { !statusDisabledChange.includes(record.status) && this.props.permisions.allowChangeStatus && 
                        <Tooltip title={this.props.t(`action.changeStatus`)} placement="top">
                            <Icon type="edit" className="fs20 colorPrimary" onClick={() => this.onClickChangeStatus(record)} />
                        </Tooltip>
                        }
                        { 
                            // this.props.allowSurcharge && 
                            // <Tooltip title='Thêm phụ thu' placement="top">
                            //     <Icon type="file-add" className="fs20 colorPrimary" onClick={() => this.props.createModalSurcharge(record.itemVariantId, ORDER.TYPES.VINWONDER.id)} />
                            // </Tooltip>
                        }
                        
                        </Fragment>
                }
            },
            componentTableCustomer: {
                fullName: {
                    width: 200,
                    fixed: 'left',
                },
                dateOfBirth: {
                    render: (date) => date && (getMomentDate(date) || getMomentDate(new Date().toISOString())).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                sex: {
                    render: (sex) => sex !== undefined && this.props.t(`item.flight.genderTypes.${sex}`)
                }
            },
            expandedRows: [],
            dataItem: null
        };
    }

    render() {
        const { t, vinWonders, loading } = this.props;
        const { titleOrderCustomerTable, titleOrderItemTable, modelOrderItem, modelOrderCustomer, componentTable, componentTableCustomer, expandedRows, dataItem } = this.state;

        return (
            vinWonders && vinWonders.length > 0 && vinWonders.map((item, idx)=>{
                return(
                    <Wrapper className="col-md-12 mt-4 vin-wonder-info-section" key={idx}>
                        <h3 className={`ml-0`}>{t('item.order.vinWonderInfo')}</h3>
                        {
                            item.bookingItems && item.bookingItems.length > 0 &&
                            <Wrapper className={`row mt-2 mb-3`}>
                                <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
                                    {!loading ?
                                        <ListComponent
                                            classParent="m-0 p-0 col-md-12"
                                            marginTop={'0'} marginBottom={'0'}
                                            loading={{ spinning: loading, size: 'large' }}
                                            rowKey={(record, k) => k}
                                            dataSource={Func.getDataSource(item.bookingItems, modelOrderItem)}
                                            columns={Func.columnsTable({
                                                titleTable: titleOrderItemTable,
                                                component: componentTable,
                                                itemName: 'vinWonder'
                                            })}
                                            componentTableList={{}}
                                            hideSettings={true}
                                            expandedRowRender={this.renderSurcharge}
                                            onExpand={this.onRowExpanded}
                                            onColumnVisibleChange={this.onColumnVisibleChange}
                                            expandedRowKeys={expandedRows}
                                            onExpandedRowsChange={expandedRows => this.setState({ expandedRows })}
                                        />
                                        : <Skeleton active paragraph={{ row: 3 }} className="p-4" />
                                    }
                                </FormWrapperItem>
                            </Wrapper>
                        }
                        {
                            item.bookingCustomers && item.bookingCustomers.length > 0 && 
                            <Wrapper>
                                <h3 className={`ml-0 `}>{t('item.order.vinWonderCustomer')}</h3>
                                <Wrapper className={`row mt-2`}>
                                    <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
                                        {!loading ?
                                            <ListComponent
                                                classParent="m-0 p-0 col-md-12"
                                                marginTop={'0'} marginBottom={'0'}
                                                loading={{ spinning: loading, size: 'large' }}
                                                rowKey={(record, k) => k}
                                                dataSource={Func.getDataSource(item.bookingCustomers, modelOrderCustomer)}
                                                columns={Func.columnsTable({
                                                    titleTable: titleOrderCustomerTable,
                                                    component: componentTableCustomer,
                                                    itemName: 'vinWonder'
                                                })}
                                                scroll={{ x: 2000 }}
                                                componentTableList={{}}
                                                hideSettings={true}
                                            />
                                            : <Skeleton active paragraph={{ row: 3 }} className="p-4" />
                                        }
                                    </FormWrapperItem>
                                </Wrapper>
                            </Wrapper>
                        }
                        <DetailStatusItem 
                            title={`${t('item.order.changeStatus')} ${t('item.vinWonder.title').toLowerCase()}`}
                            visible={!!dataItem}
                            onSave={this.onSaveStatus}
                            itemTypes={ORDER.TYPE_ITEM['5']}
                            onClose={() => this.setState({ dataItem: null })}
                            item={dataItem || {}}
                            keyName={'vinWonderName'}
                        />
                    </Wrapper>
                )
            })
        );
    }

    renderSurcharge = (record, index, indent, expanded) => {
        return (
            <SurchargeInfo
                listType='vinWonders'
                removeSurcharge={this.props.removeSurcharge}
                surcharges={record.detail.items}
                loading={false}
                openModalDetail={this.props.openDetailSurcharge}
            />
        )
    }

    onRowExpanded = (expanded, record) => {
        if (expanded && record.itemVariantId) {
            this.props.onItemExpanded(expanded, record, 'vinWonders')
        }
    }

    onColumnVisibleChange = () => {

    }

    onClickChangeStatus = (item) => {
        this.setState({ dataItem: item })
    }

    onSaveStatus = (orderItem) => {
        if(this.props.onUpdateItem){
            orderItem.orderItemType = 5;
            this.props.onUpdateItem(orderItem)
        }
        this.setState({ dataItem: null })
    }
    
}

VinWonderInfo.defaultProps = {
    order: new Order(),
    loading: false,
    data: {},
};